import React from "react";
import { PageNewState, InfraTicketDescriptionDialogInitialState } from ".";

export const InfraTicketDescriptionDialogContext = React.createContext({
  pageState: InfraTicketDescriptionDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
